import { Link } from 'react-router-dom'
import ArrowDownSmallIcon from '../../../icons/ArrowDownSmallIcon'
import { useState } from 'react'
import ArrowUpIcon from '../../../icons/ArrowUpIcon'
import { useTranslation } from 'react-i18next'

const RegisterDropdown = ({ isQuickOffer }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <div>
      <div className="dropdown">
        <a
          className="dropdown-toggle text-bg-tertiary text-decoration-none d-flex justify-content-center align-items-center gap-1"
          href="#"
          role="button"
          id="dropdownMenuLink"
          data-bs-toggle="dropdown"
          onClick={() => setOpen((prevState) => !prevState)}
        >
          <span
            className={`font-small ${
              isQuickOffer ? 'text-on-bg-primary' : 'text-on-bg-primary'
            }`}
          >
            {t('sign_up')}
          </span>
          {open ? (
            <ArrowUpIcon fill={isQuickOffer ? '#044846' : '#FAFAFA'} />
          ) : (
            <ArrowDownSmallIcon fill={isQuickOffer ? '#044846' : '#FAFAFA'} />
          )}
        </a>
        <ul
          className="dropdown-menu font-extra-small"
          aria-labelledby="dropdownMenuLink"
          style={{
            left: '-5rem',
          }}
        >
          <li>
            <Link
              className="dropdown-item"
              to="/register-company"
              state={window.location.pathname}
            >
              <div className="d-flex justify-content-start align-items-center gap-1">
                <span>ERES EMPRESA</span>
              </div>
            </Link>
          </li>
          <li>
            <Link
              className="dropdown-item"
              to="/register-talent"
              state={window.location.pathname}
            >
              <div className="d-flex justify-content-start align-items-center gap-1">
                <span>ERES TALENTO</span>
              </div>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default RegisterDropdown
